'use client';

import { useTranslations } from 'next-intl';
import type { PropertyDetailListing } from '@/src/components/features/property/types';
import { isUserOnWaitlist, isWaitlistedListing } from '@/src/components/features/property/lib/waitlist';
import * as styles from './waitlistNotice.styles';

type Props = {
  listing: PropertyDetailListing;
};

export const WaitlistNotice = ({ listing }: Props) => {
  const t = useTranslations('hdp');

  if (!isWaitlistedListing(listing) || listing.active === false) {
    return null;
  }

  return (
    <div className={styles.container} role="status">
      {isUserOnWaitlist(listing) ? t('waitlistNoticeJoined') : t('waitlistNotice')}
    </div>
  );
};
